export const contingencyTypes = [{ id: 'USER_DEFINED' }, { id: 'PERCENTAGE' }]
